var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArtNewhome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m24.477 8.468 16.522 19v16.106H20a1 1 0 0 0 1-1v-13a1 1 0 0 0-1-1h-6c-.551 0-1 .448-1 1v13a1 1 0 0 0 1 1H6v-15L24.477 8.468zM34 28.574h-8a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1z",
    fill: "#A4C5F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47 42.574a1 1 0 0 1 .117 1.993l-.117.007H1a1 1 0 0 1-.117-1.993L1 42.574h46z",
    fill: "#424A56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.97 4.293 2.382 24.879a.999.999 0 0 0 0 1.414l2.586 2.586a1 1 0 0 0 1.414 0L22.97 12.293a.999.999 0 0 1 1.414 0L40.97 28.879a1 1 0 0 0 1.414 0l2.586-2.586a1 1 0 0 0 0-1.414L24.383 4.293a.999.999 0 0 0-1.414 0",
    fill: "#5593E7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.676 5.586a1 1 0 0 1 .993.883l.007.117v7a1 1 0 0 1-1.994.116l-.006-.116-.001-6h-4v12a1 1 0 0 1-.883.993l-.116.007a1 1 0 0 1-.994-.884l-.006-.116v-13a1 1 0 0 1 .883-.993l.117-.007h6z",
    fill: "#424A56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtNewhome);
export default __webpack_public_path__ + "static/media/art-newhome.2fcb470ecdff107fc6244fdc0f0e5127.svg";
export { ForwardRef as ReactComponent };